import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import PhoneInput from 'react-phone-number-input'
import { Modal, Form, Row, Col, Input, Button, Checkbox } from 'antd';
import i18n from "../../../../plugins/i18n/i18n";


class TripEditPessengerContactEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: {},
            loadings: {
                submit: false
            }
        };
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps) {

    }

    saveForm = (values) => {

        if (this.props.type === "create") {

            this.props.addPassenger({
                name: values.name,
                lastname: values.lastname,
                phoneNumber: values.phoneNumber.replace('+', ''),
                email: values.email,
                isContact: false
            })

            this.props.handleToggle()

            if (values.isSave) {
                this.fetchContact({
                    name: values.name,
                    lastname: values.lastname,
                    phoneNumber: values.phoneNumber.replace('+', ''),
                    email: values.email,
                    isContact: false
                })
            }
        } else {
            this.props.changePassenger({
                name: values.name,
                lastname: values.lastname,
                phoneNumber: values.phoneNumber.replace('+', ''),
                email: values.email
            })

            this.props.handleToggle()

        }
    }

    fetchContact = (values) => {

        let endpoint = { keyOne: "contact" };

        let { form } = this.state;

        var param = values;
        param.latitude = form.latitude;
        param.longitude = form.longitude;

        this.props
            .dispatch(
                actions.definitions.addData({
                    ...endpoint,
                    data: values,
                })
            )
            .then((response) => { })
            .catch(error => { })
    };


    render() {

        const { handleToggle, isModalOpen, selectedContact, type } = this.props;


        return (

            <Modal
                className='select-contact-form-modal'
                title="Kişi Ekle" centered open={isModalOpen} onOk={handleToggle} onCancel={handleToggle}
                maskClosable={false}
                footer={null}
                destroyOnClose={true}
                width={650}
                style={{ paddingTop: 5 }}
            >
                <Form layout="vertical" className='form-box'
                    onFinish={this.saveForm}>

                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Form.Item
                                label={`${i18n.t("name", {
                                    lng: this.props.currentLanguage,
                                })}`}
                                name="name"
                                rules={[
                                    {
                                        required: true,
                                        message: `${i18n.t("fieldIsRequired", {
                                            lng: this.props.currentLanguage,
                                        })}`,
                                    },
                                ]}
                                initialValue={type === "update" ? selectedContact.name : null}
                            >
                                <Input
                                    placeholder={i18n.t("name", {
                                        lng: this.props.currentLanguage,
                                    })}
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Form.Item
                                label={`${i18n.t("lastname", {
                                    lng: this.props.currentLanguage,
                                })}`}
                                name="lastname"
                                rules={[
                                    {
                                        required: true,
                                        message: `${i18n.t("fieldIsRequired", {
                                            lng: this.props.currentLanguage,
                                        })}`,
                                    },
                                ]}
                                initialValue={type === "update" ? selectedContact.lastname : null}

                            >
                                <Input
                                    placeholder={i18n.t("lastname", {
                                        lng: this.props.currentLanguage,
                                    })}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>

                            <Form.Item
                                label={`${i18n.t("phoneNumber", {
                                    lng: this.props.currentLanguage,
                                })}`}
                                name="phoneNumber"
                                rules={[
                                    {
                                        required: true,
                                        message: `${i18n.t("fieldIsRequired", {
                                            lng: this.props.currentLanguage,
                                        })}`,
                                    },
                                ]}
                                initialValue={type === "update" ? '+' + selectedContact.phoneNumber : null}

                            >
                                <PhoneInput
                                    country="TR"
                                    placeholder="+90 555 555 55 55"
                                />
                            </Form.Item>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Form.Item
                                label={`${i18n.t("email", {
                                    lng: this.props.currentLanguage,
                                })}`}
                                name="email"
                                tooltip={`${i18n.t("emailCannotChange", {
                                    lng: this.props.currentLanguage,
                                })}`}

                                rules={[
                                    {
                                        required: true,
                                        message: `${i18n.t("fieldIsRequired", {
                                            lng: this.props.currentLanguage,
                                        })}`,
                                    },
                                    {
                                        type: 'email',
                                        message: 'Geçerli bir email yazınz.',
                                    },
                                ]}
                                initialValue={type === "update" ? selectedContact.email : null}

                            >
                                <Input
                                    type="email"
                                    placeholder={i18n.t("email", {
                                        lng: this.props.currentLanguage,
                                    })}
                                />
                            </Form.Item>
                        </Col>

                    </Row>
                    {
                        this.props.type === "create" &&
                        <Row>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>

                                <Form.Item
                                    label=""
                                    name="isSave"
                                    valuePropName="checked"
                                >
                                    <Checkbox>
                                        Bu kişiyi, kişilerim listesine de kaydet
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item className="form-item-submit">
                                <Button
                                    htmlType="submit"
                                    type="primary"
                                    className="ant-btn width-100"
                                    style={{ height: 40, marginTop: 20 }}
                                    loading={this.state.loadings.submit}
                                >
                                    {
                                        type === "create" ? "Kişi Ekle" : "Kaydet"
                                    }
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = ({ account }) => ({ ...account });
export default connect(mapStateToProps)(TripEditPessengerContactEdit);


// WEBPACK FOOTER //
// ./src/components/App/Views/Trip/TripEditPessengerContactEdit.js